module.exports = __webpack_public_path__ + "img/theme8Tran.941c88c8.png";